const lStorage = window.localStorage;

class CacheMemory {
    constructor() {
    }

    toBase64(str) {
        return window.btoa(str);
    }

    fromBase64(str) {
        return window.atob(str);
    }

    serialize(exin, data) {
        return exin+';'+this.toBase64(JSON.stringify(data));
    }

    deserialize(v) {
        const [expiresIn, rawValue] = v.split(';');
        const exin = Number(expiresIn);
        if (exin !== -1 && Date.now() > exin) {
            return null;
        }
        return JSON.parse(this.fromBase64(rawValue));
    }

    remove(key) {
        lStorage.removeItem(key);
        return this;
    }

    set(key, value, expiresIn) {
        let exin = '-1';
        if (typeof expiresIn === 'number') {
            exin = expiresIn;
        }
        lStorage.setItem(key, this.serialize(exin, value));
        return this;
    }

    get(key, autoRemove) {
        const rawValue = lStorage.getItem(key);
        if (!rawValue) return null;
        const value = this.deserialize(rawValue);
        if (rawValue === null && autoRemove === true) {
            this.remove(key);
        }
        return value;
    }
}

export default new CacheMemory();